module.exports = __webpack_public_path__ + "img/marty.261415f5.webp";